import http from './base/http';
// 收入类比管理列表
export function incomeTypeList(data) {
  const params = { // http请求的参数
    SERVICE_ID: '10007',
    OTYPE: 3,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 新增收入类别
export function addIncomeType(data) {
  const params = { // http请求的参数
    SERVICE_ID: '10007',
    OTYPE: 1,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 修改收入类别
export function editIncomeType(data) {
  const params = { // http请求的参数
    SERVICE_ID: '10007',
    OTYPE: 7,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/api/incomeType.js